var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import styled from 'styled-components';
import 'react-select-v1/dist/react-select.css';
import { c, h } from '@debbie/cortex/dist';
import { CreditorState } from '@debbie/common/dist/creditor';
import { useAllCreditors } from '@debbie/cortex/dist/creditors';
const CreditorSelector = (props) => {
    const selectedCreditors = useSelector((s) => s.caseFilter.creditorIds);
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : [];
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", { style: props.style },
        React.createElement(StyledSelect, { value: (selectedCreditors || []).map((cId) => {
                const creditor = creditors.find((c) => c.creditorId === cId);
                return {
                    label: ((creditor === null || creditor === void 0 ? void 0 : creditor.state) && creditor.state !== CreditorState.Active
                        ? `${lang.creditors.states[creditor.state]}: `
                        : '') + ((creditor === null || creditor === void 0 ? void 0 : creditor.name) || 'Error: Not found'),
                    value: creditor === null || creditor === void 0 ? void 0 : creditor.creditorId,
                };
            }), isMulti: true, placeholder: lang.inputs.creditorSelect, name: "creditors", className: "creditors-select", classNamePrefix: "select", options: creditors.map((creditor) => ({
                label: ((creditor === null || creditor === void 0 ? void 0 : creditor.state) && creditor.state !== CreditorState.Active
                    ? `${lang.creditors.states[creditor.state]}: `
                    : '') + creditor.name,
                value: creditor.creditorId,
            })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                const selected = val != null ? val.map((v) => v.value) : [];
                c.insights.setSelectedCreditors(selected);
                props.onChange && props.onChange(selected);
            }) })));
};
export default CreditorSelector;
const StyledSelect = styled(Select) `
  & > .select__menu {
    z-index: 2;
  }
`;
//# sourceMappingURL=CreditorSelector.js.map